document.addEventListener('DOMContentLoaded', function () {
  window.applyFilterToggleEvent();
});
window.applyFilterToggleEvent = function(){
  if(document.querySelector("height-observer .collection-toolbar__button-container")){
    if(!document.querySelector("height-observer .collection-toolbar__button-container").classList.contains('event-added')){
      document.querySelector("height-observer .collection-toolbar__button-container").classList.add("event-added")
      document.querySelector("height-observer .collection-toolbar__button-container").addEventListener("click", function(e){
        document.body.classList.toggle("collection-filter__enable");
      })
    }
  }
  
  if(document.querySelector("safe-sticky .icon-filter-close-btn")){
    if(!document.querySelector("safe-sticky .icon-filter-close-btn").classList.contains('event-added')){
      document.querySelector("safe-sticky .icon-filter-close-btn").classList.add("event-added")
      document.querySelector("safe-sticky .icon-filter-close-btn").addEventListener("click", function(e){
        document.body.classList.toggle("collection-filter__enable");
      })
    }
  }
}



/* Load more -- Start */
if(document.querySelectorAll(".load-more-wrapper .load-more").length > 0){
  let eventSelectors  = {
    _loadMoreButton : document.querySelector(".load-more-wrapper .load-more"),      
    _currentPage: 1
  }
  window.loadMoreProducts = {
    _init : function(){
      this._eventBinder();
      this._resetValuesOnFilterChange();
    },
    _eventBinder : function() {
      eventSelectors._loadMoreButton = document.querySelector(".load-more-wrapper .load-more");
      if(eventSelectors._loadMoreButton){
        eventSelectors._loadMoreButton.addEventListener('click', this._handleLoadMore.bind(this), true );
      }
    },
    _updatePageQueryParam: function (url, newPage) {
      const urlObj = new URL(url);
      urlObj.searchParams.set('page', newPage);
      return urlObj.toString();
    },
    _handleLoadMore : function(event){
      event.preventDefault();
      if(document.querySelectorAll(".pagination-wrapper").length > 0){
        eventSelectors._totalPages = parseInt(document.querySelector(".pagination-wrapper").dataset.total_pages)
        if(eventSelectors._currentPage <= eventSelectors._totalPages){
          eventSelectors._currentPage = eventSelectors._currentPage + 1;
          let fetchUrl = this._updatePageQueryParam(window.location.href, eventSelectors._currentPage);
          this._fetchAndAppendProductGrids(fetchUrl);
          this._showHideLoadMoreButton()
        }
      }
    },
    _fetchAndAppendProductGrids: function(fetchUrl){
      fetch(fetchUrl)
      .then(response => response.text())
      .then(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const productGrid = tempDiv.querySelector('.collection__main product-list');
        if (productGrid) {
          const childElements = productGrid.children;
          const targetElement = document.querySelector('.collection__main product-list');
          for (let i = 0; i < childElements.length; i++) {
            const child = childElements[i];
            child.style.transition = "opacity 0.2s ease-in-out, transform 0.2s ease-in-out";
            child.style.opacity = "1";
            child.style.transform = "translateY(0px)";
            targetElement.appendChild(childElements[i].cloneNode(true));
          }          
        } else {
          console.log('#product-grid not found in the HTML.');
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
    },
    _showHideLoadMoreButton(){
      (eventSelectors._currentPage >= eventSelectors._totalPages) ? eventSelectors._loadMoreButton.classList.add("hidden") : eventSelectors._loadMoreButton.classList.remove("hidden") ;
    },
    _resetValuesOnFilterChange: function(){
      if(document.querySelectorAll(".pagination-wrapper").length == 0){
        if(eventSelectors._loadMoreButton){
          eventSelectors._loadMoreButton.classList.add("hidden");
        }
      }
      eventSelectors._currentPage = 1;
    }
  }
  window.loadMoreProducts._init();
}
/* Load more -- End */

/* Price filter on collection page */ 
document.addEventListener('click', (event) => {
  const label = event.target.closest('.price-checkbox-control');
  if (!label) return; 

  const accordion = label.closest('accordion-disclosure');
  if (!accordion) return;

  const filterForm = accordion.closest('form');
  if (!filterForm) {
    console.error("Form element not found. Ensure the filter is inside a form.");
    return;
  }

  const filterGte = filterForm.querySelector('#filter\\.v\\.price\\.gte');
  const filterLte = filterForm.querySelector('#filter\\.v\\.price\\.lte');
  const rangeElement = filterForm.querySelector('.min-range-group');
  if (!filterGte || !filterLte) {
    console.error("Filter inputs not found. Check your selectors.");
    return;
  }
  const minPriceValue = rangeElement.getAttribute('min');
  const maxPriceValue = rangeElement.getAttribute('max');
  
  const input = label.querySelector('input[type="checkbox"]');
  if (!input) return;

  if (input.checked) {
    filterGte.value = '';
    filterLte.value = '';
  } else {
    const minValue = input.getAttribute('data-min-value');
    const maxValue = input.getAttribute('data-max-value');
    if (minValue && maxValue) {
      filterGte.value = minValue;
      filterLte.value = maxValue;
    } else if (maxValue) {
      filterGte.value = '';
      filterLte.min = minValue;
      filterLte.max = maxValue;
      filterLte.value = maxValue;
    } else if (minValue) {
      filterLte.value = '';
      filterGte.min = minValue;
      filterGte.max = maxPriceValue;
      filterGte.value = minValue;
    }
  }

  filterForm.dispatchEvent(new Event('submit', { bubbles: true }));
  setTimeout(function(){
    filterGte.dispatchEvent(new Event('change', { bubbles: true }));
  },500);  
});
/* Price filter on collection page -- End */


(function () {
  // Vertical Tabs
  const tabContents = document.querySelectorAll('.js-vertical-tab-content');
  const tabs = document.querySelectorAll('.js-vertical-tab');
  const accordionHeadings = document.querySelectorAll('.js-vertical-tab-accordion-heading');

  // Hide all tab contents and show the first one
  tabContents.forEach((content, index) => {
    content.style.display = index === 0 ? 'block' : 'none';
  });

  // Tab mode click event
  tabs.forEach(tab => {
    tab.addEventListener('click', function (event) {
      event.preventDefault();

      // Hide all tab contents
      tabContents.forEach(content => {
        content.style.display = 'none';
      });

      // Show the active tab content
      const activeTab = this.getAttribute('rel');
      const activeContent = document.getElementById(activeTab);
      if (activeContent) {
        activeContent.style.display = 'block';
      }

      // Update active classes
      tabs.forEach(tab => tab.classList.remove('is-active'));
      this.classList.add('is-active');

      accordionHeadings.forEach(heading => heading.classList.remove('is-active'));
      const activeAccordionHeading = document.querySelector(`.js-vertical-tab-accordion-heading[rel='${activeTab}']`);
      if (activeAccordionHeading) {
        activeAccordionHeading.classList.add('is-active');
      }
    });
  });

  // Accordion mode click event
  accordionHeadings.forEach(heading => {
    heading.addEventListener('click', function (event) {
      event.preventDefault();

      // Hide all tab contents
      tabContents.forEach(content => {
        content.style.display = 'none';
      });

      // Show the active tab content
      const accordionActiveTab = this.getAttribute('rel');
      const activeContent = document.getElementById(accordionActiveTab);
      if (activeContent) {
        activeContent.style.display = 'block';
      }

      // Update active classes
      accordionHeadings.forEach(heading => heading.classList.remove('is-active'));
      this.classList.add('is-active');

      tabs.forEach(tab => tab.classList.remove('is-active'));
      const activeTab = document.querySelector(`.js-vertical-tab[rel='${accordionActiveTab}']`);
      if (activeTab) {
        activeTab.classList.add('is-active');
      }
    });
  });
})();

// image slider
 const swiper = new Swiper('.image-slider .swiper', {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    480: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
});

document.addEventListener("DOMContentLoaded", function () {
    const slides = document.querySelectorAll(".collection-with-image .slideshow__slide");

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add("in-view");
            } else {
                entry.target.classList.remove("in-view");
            }
        });
    }, { threshold: 0.5 }); // Adjust threshold if needed

    slides.forEach((slide) => observer.observe(slide));
});
